import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForNewsletterTargetComponent extends Component {
  // Defaults
  availableFilters = [
    {
      key: 'type',
      type: 'selectValueLabel',
      options: ['artist', 'crossArtist'],
    },
    {
      key: 'legalContext',
      type: 'selectRelationship',
      recordType: 'organization',
    },
  ];

  defaultColumns = ['id', 'name', 'type', 'language'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      isMainColumn: true,
    },
    {
      property: 'language',
    },
    {
      property: 'type',
    },
  ];
}
